import React, { useState, useMemo } from 'react';
import DrilldownCard from '../DrillDownCard';
import BottomSheet from '../DrillDownCard/subcomponents/BottomSheet';
import Table from '../Table/Table';
import UsageHistoryTableView from '../UsageHistoryTableView';
import Label from '../Label';
import { addDaysUTC } from '../../../utils/dates';
import ToggleButton from '../ToggleButtonV2';

const formatLongDate = (iso) => {
  const [y, m, d] = (iso || '').split('-').map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1);
  return dt.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

const DailyCards = ({ dailyItems }) => {
  const [open, setOpen] = useState(false);
  const [showEventsWithTransit, setShowEventsWithTransit] = useState(true);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const title = useMemo(() => {
    const nice = dailyItems?.date || dailyItems?.value;
    return `Activity Breakdown – ${formatLongDate(nice)}`;
  }, [dailyItems]);

  const openSheet = () => {
    setOpen(true);
    setStartDate(dailyItems.date);
    setEndDate(addDaysUTC(dailyItems.date));
  };

  const handleShowTransit = () => {
    setShowEventsWithTransit((prev) => !prev);
  };

  return (
    <>
      {/* Fallback: si el card no propaga onNavigate, el wrapper abre igual */}
      <div
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openSheet()}
      >
        <DrilldownCard
          title={dailyItems?.label}
          subtitle={dailyItems?.date || dailyItems?.value || dailyItems?.label}
          metrics={dailyItems?.metrics}
          navigable
          shouldExpand={false}
          showViewDetails
          onClickDaily={openSheet}
        />
      </div>

      <BottomSheet open={open} onClose={() => setOpen(false)} title={title}>
        {/* tu tabla va acá */}
        <div className="space-y-4">
          <div className="toggle-container flex sm:justify-end my-6">
            <Label variant="gray">Show Transits</Label>
            <ToggleButton status={showEventsWithTransit} onToggle={handleShowTransit} />
          </div>
          <div className="rounded-xl border border-gray-200 p-4 mb-[25px]">
            {open && (
              <UsageHistoryTableView
                filterParams={{
                  show_transit: showEventsWithTransit,
                  start_date: startDate,
                  end_date: endDate,
                }}
                areFiltersActive={false}
                recordsPerPage={10}
              >
                {({ currentRecords, columns }) => <Table columns={columns} data={currentRecords} />}
              </UsageHistoryTableView>
            )}
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default DailyCards;
